// 2020-06-27export { TropaCrudComponent } from './tropa-crud.component';